// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.gc-agency-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

p.gc-agency-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.gc-agency-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-badge-gold:before {
  content: "\\e900";
  color: #f2c94c;
}

.gc-user-img {
  width: 46px;
  height: 46px;
  font-size: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #E7ECF0;
}

.status-true {
  color: #FF3C3C;
}

.status-false {
  color: #10B981;
}

.clearBtn {
  background: none;
  border: none;
  padding-right: 10px;
  cursor: pointer;
}

.MRN-id {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5019607843);
}

.m-l-5 {
  margin-left: 5px;
}

.gc-agency-handle {
  width: 160px;
}

.m-l-24 {
  margin-left: 24px;
}

.p-button.button-sm {
  height: 32px;
  line-height: 15px;
  font-size: 14px;
  font-weight: 300;
  margin-right: 10px;
}

.gap-1 {
  gap: 1rem;
}

.w-165 {
  width: 165px !important;
}

.responsive-table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.col-doc {
  min-width: 140px !important;
  max-width: 220px !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.col-recipient {
  min-width: 140px !important;
  max-width: 220px !important;
  word-break: break-all !important;
  overflow-wrap: break-word !important;
}

.col-date {
  min-width: 130px !important;
  white-space: nowrap !important;
}

.col-status {
  min-width: 90px !important;
  text-align: center !important;
}

.col-action {
  min-width: 80px !important;
  text-align: center !important;
}

.col-resends {
  min-width: 80px !important;
  text-align: center !important;
}

/* PDF.js Annotation Layer styles moved to global styles.scss to avoid Angular ViewEncapsulation */
/* Premium PDF Loading Overlay */
.pdf-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.45); /* Elegant dark glass tint */
  backdrop-filter: blur(8px); /* Soft modern blur */
  -webkit-backdrop-filter: blur(8px);
  z-index: 11000; /* Keep it above PrimeNG sidebar and dialogs */
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.25s ease-out;
}

.pdf-loading-card {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 380px;
  width: 90%;
  animation: scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes scaleUp {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
::ng-deep .p-accordion .p-accordion-tab {
  margin-bottom: 12px;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
  padding: 1.25rem 1.5rem !important;
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  text-decoration: none !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05) !important;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
  color: #64748b !important;
  font-size: 1.1rem !important;
  margin-right: 1rem !important;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-header.p-accordion-header-active .p-accordion-header-link {
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  box-shadow: none !important;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-content {
  border: 1px solid #e2e8f0 !important;
  border-top: none !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  padding: 1.5rem !important;
  background: #ffffff !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

/* Dropdown Clear Icon styling to prevent overlapping text */
::ng-deep .p-dropdown.p-dropdown-clearable .p-dropdown-label {
  padding-right: 3.5rem !important;
}
::ng-deep .p-dropdown.p-dropdown-clearable .p-dropdown-clear-icon {
  background: #ffffff !important;
  padding: 3px !important;
  border-radius: 50% !important;
  right: 2.2rem !important;
  color: #ef4444 !important; /* soft red cross */
  font-weight: bold !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 16px !important;
  height: 16px !important;
  font-size: 10px !important;
}

/* Visual PDF Form Mapping Overlays and Selector Menu */
::ng-deep .assigned-sig-field, ::ng-deep .assigned-date-field, ::ng-deep .unassigned-sig-field {
  transition: all 0.2s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
::ng-deep .assigned-sig-field:hover, ::ng-deep .assigned-date-field:hover, ::ng-deep .unassigned-sig-field:hover {
  filter: brightness(0.95);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
::ng-deep .field-assignment-badge {
  font-family: "Montserrat", sans-serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  line-height: 1.2 !important;
}

.signer-select-popup {
  font-family: "Montserrat", sans-serif;
  animation: fadeInFast 0.15s ease-out;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

@keyframes fadeInFast {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
::ng-deep .pdf-form-fill-dialog {
  /* Top-align the dialog (position="top" on the p-dialog) instead of vertical-centering,
     so the large empty margin above the modal is removed; a small top margin keeps it from
     being glued to the browser chrome. The leftover vertical slack now sits below the modal. */
}
::ng-deep .pdf-form-fill-dialog .p-dialog {
  margin-top: 1rem !important;
}
::ng-deep .pdf-form-fill-dialog .p-dialog-content {
  overflow: visible !important;
  /* Trim the default content top padding so the form/document sits right under the
     header instead of floating with a large empty gap above it. */
  padding-top: 0.5rem !important;
}

::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 16px !important;
  padding: 20px 24px !important;
  background: #fff !important;
  border-top: 1px solid #e5e7eb !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .p-button {
  width: auto !important;
  min-width: 140px !important;
  height: 48px !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 0 24px !important;
  letter-spacing: -0.25px !important;
  box-shadow: none !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.close-btn, ::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.save-btn {
  background-color: #fff !important;
  border: 1px solid #2d388b !important;
  color: #2d388b !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.close-btn:enabled:hover, ::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.save-btn:enabled:hover {
  background-color: #f3f4f6 !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.close-btn:disabled, ::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.save-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send {
  /* IOHB-1632: the pale custom green never read as "ready". Match the app's
     standard green button (.esign-green-btn / \$Green) so it's consistent with
     the other enabled green buttons. */
  background-color: #6ACE6A !important;
  color: #ffffff !important;
  border: 1px solid #6ACE6A !important;
  /* IOHB-1632 follow-up: a disabled button must not stay vibrant green —
     users read it as clickable and get no feedback. Mute it like the other
     disabled buttons in this footer. */
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send:enabled:hover {
  background-color: #7AEC7A !important;
  border-color: #7AEC7A !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send:enabled:focus, ::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send:enabled:active {
  background-color: #5CB85C !important;
  border-color: #5CB85C !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send:disabled {
  opacity: 0.5 !important;
  background-color: #9ca3af !important;
  border-color: #9ca3af !important;
  color: #f3f4f6 !important;
  cursor: not-allowed !important;
}

::ng-deep .pdf-zoom-controls {
  position: absolute;
  right: 28px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
}
::ng-deep .pdf-zoom-controls button {
  width: 38px !important;
  height: 38px !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: #2D388B !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  padding: 0 !important;
  transition: transform 0.1s ease, background-color 0.2s;
}
::ng-deep .pdf-zoom-controls button:hover:not(:disabled) {
  background-color: #f9fafb !important;
  transform: scale(1.05);
}
::ng-deep .pdf-zoom-controls button:active:not(:disabled) {
  transform: scale(0.95);
}
::ng-deep .pdf-zoom-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
::ng-deep .pdf-zoom-controls button i {
  font-size: 14px !important;
  font-weight: 700 !important;
}
::ng-deep .pdf-zoom-controls .zoom-percent {
  width: 38px;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: #2D388B;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 4px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

@media (max-width: 991px), (pointer: coarse) {
  ::ng-deep .pdf-zoom-controls {
    top: 12px !important;
    right: 12px !important;
    bottom: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/e-soc/e-soc/esoc.component.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;ADEA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGJ;;AADE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AAIJ;;AAFE;EACI,oBAAA;EACA,eAAA;EACA,YAAA;AAKN;;AAHE;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAMN;;AAHE;EACE,gBAAA;EACA,cAAA;AAMJ;;AAHA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAMF;;AAHA;EACE,cAAA;AAMF;;AAHA;EACC,cAAA;AAMD;;AAJA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAOF;;AALA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;AAQF;;AALA;EACE,gBAAA;AAQF;;AANA;EACI,YAAA;AASJ;;AANA;EACE,iBAAA;AASF;;AAPA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAUF;;AAPA;EACE,SAAA;AAUF;;AARA;EACE,uBAAA;AAWF;;AARA;EACE,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAWF;;AARA;EACE,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,oCAAA;AAWF;;AARA;EACE,2BAAA;EACA,2BAAA;EACA,gCAAA;EACA,oCAAA;AAWF;;AARA;EACE,2BAAA;EACA,8BAAA;AAWF;;AARA;EACE,0BAAA;EACA,6BAAA;AAWF;;AARA;EACE,0BAAA;EACA,6BAAA;AAWF;;AARA;EACE,0BAAA;EACA,6BAAA;AAWF;;AARA,kGAAA;AAEA,gCAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA,EAAA,4BAAA;EACA,0BAAA,EAAA,qBAAA;EACA,kCAAA;EACA,cAAA,EAAA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAUF;;AAPA;EACE,qCAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;EACA,mFAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,yDAAA;AAUF;;AAPA;EACE;IAAO,UAAA;EAWP;EAVA;IAAK,UAAA;EAaL;AACF;AAXA;EACE;IACE,UAAA;IACA,qBAAA;EAaF;EAXA;IACE,UAAA;IACA,mBAAA;EAaF;AACF;AATE;EACE,mBAAA;AAWJ;AARM;EACE,kCAAA;EACA,8BAAA;EACA,oCAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,sCAAA;EACA,gCAAA;EACA,sDAAA;AAUR;AARQ;EACE,8BAAA;EACA,gCAAA;EACA,gCAAA;EACA,sDAAA;AAUV;AAPQ;EACE,yBAAA;EACA,4BAAA;EACA,6BAAA;AASV;AAJQ;EACE,8BAAA;EACA,gCAAA;EACA,uCAAA;EACA,wCAAA;EACA,2BAAA;AAMV;AADI;EACE,oCAAA;EACA,2BAAA;EACA,yCAAA;EACA,0CAAA;EACA,0BAAA;EACA,8BAAA;EACA,6FAAA;AAGN;;AAEA,4DAAA;AAEE;EACE,gCAAA;AAAJ;AAEE;EACE,8BAAA;EACA,uBAAA;EACA,6BAAA;EACA,wBAAA;EACA,yBAAA,EAAA,mBAAA;EACA,4BAAA;EACA,mDAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;AAAJ;;AAIA,uDAAA;AAEE;EACE,yBAAA;EACA,wCAAA;EACA,kBAAA;AAFJ;AAII;EACE,wBAAA;EACA,yCAAA;AAFN;AAME;EACE,qCAAA;EACA,yCAAA;EACA,oBAAA;EACA,2BAAA;AAJJ;;AAQA;EACE,qCAAA;EACA,oCAAA;EACA,yBAAA;EACA,mFAAA;AALF;;AAQA;EACE;IACE,UAAA;IACA,sBAAA;EALF;EAOA;IACE,UAAA;IACA,mBAAA;EALF;AACF;AAQA;EACE;;+FAAA;AAJF;AAOE;EACE,2BAAA;AALJ;AAQE;EACE,4BAAA;EACA;kEAAA;EAEA,8BAAA;AANJ;;AAWE;EACE,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,oBAAA;EACA,6BAAA;EACA,2BAAA;EACA,wCAAA;AARJ;AAUI;EACE,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;AARN;AAWI;EACE,iCAAA;EACA,oCAAA;EACA,yBAAA;AATN;AAWM;EACE,oCAAA;AATR;AAYM;EACE,uBAAA;EACA,8BAAA;AAVR;AAcI;EACE;;uCAAA;EAGA,oCAAA;EACA,yBAAA;EACA,oCAAA;EAaA;;uCAAA;AAtBN;AAWM;EACE,oCAAA;EACA,gCAAA;AATR;AAYM;EAEE,oCAAA;EACA,gCAAA;AAXR;AAiBM;EACE,uBAAA;EACA,oCAAA;EACA,gCAAA;EACA,yBAAA;EACA,8BAAA;AAfR;;AAqBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;AAlBF;AAoBE;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,oDAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,eAAA;EACA,qBAAA;EACA,sDAAA;AAlBJ;AAoBI;EACE,oCAAA;EACA,sBAAA;AAlBN;AAqBI;EACE,sBAAA;AAnBN;AAsBI;EACE,YAAA;EACA,mBAAA;AApBN;AAuBI;EACE,0BAAA;EACA,2BAAA;AArBN;AAyBE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,yCAAA;AAvBJ;;AA2BA;EACE;IACE,oBAAA;IACA,sBAAA;IACA,uBAAA;EAxBF;AACF","sourcesContent":["@import \"../../../assets/styles/colors.scss\";\n\n.gc-agency-name{\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 16px;\n    color: #1F2937;\n  }\n  p.gc-agency-handle{\n    font-style: italic;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 16px;\n    color: rgb(75 85 99 / 50%);\n  }\n  .disabled {\n      pointer-events: none;\n      cursor: default;\n      opacity: 0.6;\n    }\n  .gc-agency-img{\n      width: 46px;\n      height: 46px;\n      border-radius: 50%;\n      overflow: hidden;\n      background: #fff;\n      color: #2d388b;\n      text-align: center;\n      font-size: 25px;\n      font-weight: 600;\n      flex: 0 0 46px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n  }\n\n  .icon-badge-gold:before {\n    content: \"\\e900\";\n    color: #f2c94c;\n  }\n\n.gc-user-img{\n  width: 46px;\n  height: 46px;\n  font-size: 18px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: #fff;\n  color: #2d388b;\n  text-align: center;\n  font-size: 25px;\n  font-weight: 600;\n  flex: 0 0 46px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #E7ECF0;\n}\n\n.status-true {\n  color: #FF3C3C;\n}\n\n.status-false {\n color: #10B981;\n}\n.clearBtn{\n  background: none;\n  border: none;\n  padding-right: 10px;\n  cursor: pointer;\n}\n.MRN-id{\n  font-style: italic;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 16px;\n  color: #4b556380;\n}\n\n.m-l-5 {\n  margin-left: 5px;\n}\n.gc-agency-handle{\n    width: 160px;\n}\n\n.m-l-24 {\n  margin-left: 24px;\n}\n.p-button.button-sm{\n  height: 32px;\n  line-height: 15px;\n  font-size: 14px;\n  font-weight: 300;\n  margin-right: 10px;\n}\n\n.gap-1 {\n  gap: 1rem;\n}\n.w-165 {\n  width: 165px !important;\n}\n\n.responsive-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n.col-doc {\n  min-width: 140px !important;\n  max-width: 220px !important;\n  word-break: break-word !important;\n  overflow-wrap: break-word !important;\n}\n\n.col-recipient {\n  min-width: 140px !important;\n  max-width: 220px !important;\n  word-break: break-all !important;\n  overflow-wrap: break-word !important;\n}\n\n.col-date {\n  min-width: 130px !important;\n  white-space: nowrap !important;\n}\n\n.col-status {\n  min-width: 90px !important;\n  text-align: center !important;\n}\n\n.col-action {\n  min-width: 80px !important;\n  text-align: center !important;\n}\n\n.col-resends {\n  min-width: 80px !important;\n  text-align: center !important;\n}\n\n/* PDF.js Annotation Layer styles moved to global styles.scss to avoid Angular ViewEncapsulation */\n\n/* Premium PDF Loading Overlay */\n.pdf-loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(15, 23, 42, 0.45); /* Elegant dark glass tint */\n  backdrop-filter: blur(8px);        /* Soft modern blur */\n  -webkit-backdrop-filter: blur(8px);\n  z-index: 11000;                     /* Keep it above PrimeNG sidebar and dialogs */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.25s ease-out;\n}\n\n.pdf-loading-card {\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 16px;\n  padding: 2.5rem;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 380px;\n  width: 90%;\n  animation: scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes scaleUp {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n::ng-deep .p-accordion {\n  .p-accordion-tab {\n    margin-bottom: 12px;\n\n    .p-accordion-header {\n      .p-accordion-header-link {\n        padding: 1.25rem 1.5rem !important;\n        background: #ffffff !important;\n        border: 1px solid #e2e8f0 !important;\n        border-radius: 8px !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: flex-start !important;\n        transition: all 0.2s ease-in-out;\n        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;\n\n        &:hover {\n          background: #f8fafc !important;\n          border-color: #cbd5e1 !important;\n          text-decoration: none !important;\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05) !important;\n        }\n\n        .p-accordion-toggle-icon {\n          color: #64748b !important;\n          font-size: 1.1rem !important;\n          margin-right: 1rem !important;\n        }\n      }\n\n      &.p-accordion-header-active {\n        .p-accordion-header-link {\n          background: #f8fafc !important;\n          border-color: #e2e8f0 !important;\n          border-bottom-left-radius: 0 !important;\n          border-bottom-right-radius: 0 !important;\n          box-shadow: none !important;\n        }\n      }\n    }\n\n    .p-accordion-content {\n      border: 1px solid #e2e8f0 !important;\n      border-top: none !important;\n      border-bottom-left-radius: 8px !important;\n      border-bottom-right-radius: 8px !important;\n      padding: 1.5rem !important;\n      background: #ffffff !important;\n      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;\n    }\n  }\n}\n\n/* Dropdown Clear Icon styling to prevent overlapping text */\n::ng-deep .p-dropdown.p-dropdown-clearable {\n  .p-dropdown-label {\n    padding-right: 3.5rem !important;\n  }\n  .p-dropdown-clear-icon {\n    background: #ffffff !important;\n    padding: 3px !important;\n    border-radius: 50% !important;\n    right: 2.2rem !important;\n    color: #ef4444 !important; /* soft red cross */\n    font-weight: bold !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    width: 16px !important;\n    height: 16px !important;\n    font-size: 10px !important;\n  }\n}\n\n/* Visual PDF Form Mapping Overlays and Selector Menu */\n::ng-deep {\n  .assigned-sig-field, .assigned-date-field, .unassigned-sig-field {\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n\n    &:hover {\n      filter: brightness(0.95);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    }\n  }\n\n  .field-assignment-badge {\n    font-family: 'Montserrat', sans-serif;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n    pointer-events: none;\n    line-height: 1.2 !important;\n  }\n}\n\n.signer-select-popup {\n  font-family: 'Montserrat', sans-serif;\n  animation: fadeInFast 0.15s ease-out;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n@keyframes fadeInFast {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n::ng-deep .pdf-form-fill-dialog {\n  /* Top-align the dialog (position=\"top\" on the p-dialog) instead of vertical-centering,\n     so the large empty margin above the modal is removed; a small top margin keeps it from\n     being glued to the browser chrome. The leftover vertical slack now sits below the modal. */\n  .p-dialog {\n    margin-top: 1rem !important;\n  }\n\n  .p-dialog-content {\n    overflow: visible !important;\n    /* Trim the default content top padding so the form/document sits right under the\n       header instead of floating with a large empty gap above it. */\n    padding-top: 0.5rem !important;\n  }\n}\n\n::ng-deep .eSockUpdate-confirmation-dialog {\n  .p-sidebar-footer.button-container {\n    display: flex !important;\n    justify-content: flex-end !important;\n    align-items: center !important;\n    gap: 16px !important;\n    padding: 20px 24px !important;\n    background: #fff !important;\n    border-top: 1px solid #e5e7eb !important;\n\n    .p-button {\n      width: auto !important;\n      min-width: 140px !important;\n      height: 48px !important;\n      border-radius: 8px !important;\n      font-size: 16px !important;\n      font-weight: 500 !important;\n      padding: 0 24px !important;\n      letter-spacing: -0.25px !important;\n      box-shadow: none !important;\n    }\n\n    .btn-cancel.close-btn, .btn-cancel.save-btn {\n      background-color: #fff !important;\n      border: 1px solid #2d388b !important;\n      color: #2d388b !important;\n\n      &:enabled:hover {\n        background-color: #f3f4f6 !important;\n      }\n\n      &:disabled {\n        opacity: 0.5 !important;\n        cursor: not-allowed !important;\n      }\n    }\n\n    .btn-save-send {\n      /* IOHB-1632: the pale custom green never read as \"ready\". Match the app's\n         standard green button (.esign-green-btn / $Green) so it's consistent with\n         the other enabled green buttons. */\n      background-color: $Green !important;\n      color: #ffffff !important;\n      border: 1px solid $Green !important;\n\n      &:enabled:hover {\n        background-color: $Greenlight !important;\n        border-color: $Greenlight !important;\n      }\n\n      &:enabled:focus,\n      &:enabled:active {\n        background-color: $GreenDark !important;\n        border-color: $GreenDark !important;\n      }\n\n      /* IOHB-1632 follow-up: a disabled button must not stay vibrant green —\n         users read it as clickable and get no feedback. Mute it like the other\n         disabled buttons in this footer. */\n      &:disabled {\n        opacity: 0.5 !important;\n        background-color: #9ca3af !important;\n        border-color: #9ca3af !important;\n        color: #f3f4f6 !important;\n        cursor: not-allowed !important;\n      }\n    }\n  }\n}\n\n::ng-deep .pdf-zoom-controls {\n  position: absolute;\n  right: 28px;\n  bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  z-index: 1000;\n\n  button {\n    width: 38px !important;\n    height: 38px !important;\n    border-radius: 10px !important;\n    background: #ffffff !important;\n    border: 1px solid #e5e7eb !important;\n    color: #2D388B !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    cursor: pointer;\n    padding: 0 !important;\n    transition: transform 0.1s ease, background-color 0.2s;\n\n    &:hover:not(:disabled) {\n      background-color: #f9fafb !important;\n      transform: scale(1.05);\n    }\n\n    &:active:not(:disabled) {\n      transform: scale(0.95);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    i {\n      font-size: 14px !important;\n      font-weight: 700 !important;\n    }\n  }\n\n  .zoom-percent {\n    width: 38px;\n    text-align: center;\n    font-size: 11px;\n    font-weight: 700;\n    color: #2D388B;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 4px 0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  }\n}\n\n@media (max-width: 991px), (pointer: coarse) {\n  ::ng-deep .pdf-zoom-controls {\n    top: 12px !important;\n    right: 12px !important;\n    bottom: auto !important;\n  }\n}\n\n\n\n\n\n","/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
